import { styled } from '@mui/material'
import { ActionButton } from 'components/Buttons/ActionButton'
import { Flex, FlexBetween, FlexCenter, FlexColumn, FlexStart } from 'styles'

export const ButtonGroups = styled(FlexCenter)`
  width: 100%;
  height: 48px;

  border-radius: 6px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 30px;
  color: rgba(22, 25, 30, 1);
  span {
    margin-left: 8px;
  }
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  color: ${(props) => props.theme.color.bg};

  &.disable {
    cursor: not-allowed;
    color: rgba(22, 25, 30, 0.5);
    background-color: #82a14b;
  }
  &.active {
    background-color: #a0ee09;
    &:hover {
      background-color: #c7ff5c;
    }
  }
`
export const Tip = styled(FlexStart)`
  color: #f6465d;
  font-size: 12px;
  margin-bottom: 16px;
`
export const ExchangeContent = styled('div')`
  padding: 28px 24px 24px;
`

export const FormHeader = styled(FlexBetween)`
  color: rgba(149, 164, 173, 1);
  font-size: 14px;
  margin-bottom: 8px;
`

export const FormContent = styled('div')`
  height: 56px;
  margin-top: 8px;
  background-color: #16191e;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  border-bottom: 1px solid transparent;
  display: block;
  position: relative;

  @keyframes anim {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }

  &:focus-within {
    &::after {
      content: '';
      position: absolute;
      left: 0;
      width: 0;
      bottom: 0px;
      height: 1px;
      background-color: ${(props) => props.theme.color.primary30};
      animation: anim 0.3s ease-in-out;
      animation-fill-mode: forwards;
    }
  }
`
export const ExchangeButton = styled(FlexCenter)`
  width: 48px;
  height: 48px;
  border-radius: 24px;
  background-color: rgba(42, 49, 57, 1);
  cursor: pointer;
  margin: 24px auto -4px;
  transition: transform 0.2s;
  &:hover {
    .iconfont {
      color: ${(props) => props.theme.color.primary30};
    }
  }
`
export const CoinItem = styled(FlexStart)`
  margin: 0 8px;
  padding: 6px 12px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.color.text90};
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    /* background: ${(props) => props.theme.color.bgGray}; */
    background-color: rgba(42, 49, 57, 1);
  }
  img {
    display: flex;
    width: 24px;
    height: 24px;
    margin-right: 6px;
    border-radius: 50%;
  }
`
export const Space = styled('div')`
  height: 1px;
  background: ${(props) => props.theme.color.borderLayout};
  margin: 24px 0;
`
export const SelectedCoin = styled(FlexCenter)`
  img {
    width: 24px;
    height: 24px;
    border-radius: 24px;
    margin-right: 4px;
  }
  font-size: 16px;
`
export const AmountLabel = styled('span')`
  color: #fff;
  font-size: 14px;
  font-weight: 400;

  /* color: ${(props) => props.theme.color.text80}; */
`
export const BalanceLabel = styled('span')`
  font-size: 14px;
  margin-right: 4px;
  color: #95a4ad;
`
export const BalanceValue = styled(BalanceLabel)`
  color: #fff;
  margin-right: 0px;
`
export const MaxBtn = styled('div')`
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  /* margin-left: 12px; */
  color: rgba(160, 238, 9, 1);
  border-radius: 50px;
  border: 1px solid #2e363b;
  padding: 2px 12px;
  color: #fff;
  &:hover {
    color: #a0ee09;
    border: 1px solid #a0ee09;
  }
`
export const ExchangeInfoWrap = styled('div')`
  margin-bottom: 24px;
`
export const ExchangeInfoItem = styled(FlexBetween)`
  margin-top: 16px;
  color: #95a4ad;
  font-size: 14px;

  .right {
    color: #e5eaee;
  }
`
export const RangeTip = styled(Flex)`
  font-size: 12px;
  margin-top: 8px;
  color: #f6465d;
`
export const SuccessTipContent = styled(FlexColumn)`
  padding: 48px 24px;
  align-items: center;
`

export const SuccessTipText = styled('div')`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  margin-top: 16px;
  color: #fff;
`
export const SuccessTipReiceivedLabel = styled('div')`
  margin-top: 32px;
  font-size: 14px;
  color: #e5eaee;
`
export const SuccessTipReiceivedAmount = styled(SuccessTipText)`
  margin-top: 8px;
  font-size: 30px;
  font-style: 600;
  color: #fff;
`
export const DoneButton = styled(ActionButton)`
  margin-top: 32px;
  min-width: 240px;
  border-radius: 50px;
  color: #16191e;
  font-weight: 600;
  font-size: 16px;
`

export const RefreshTip = styled(Flex)`
  color: #f6465d;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  align-items: center;
  margin-bottom: 16px;
  svg {
    margin-right: 3px;
  }
`

export const ModalHeader = styled(FlexBetween)`
  width: 100%;
  /* margin-top: 20px; */
  padding: 16px 24px;
  box-sizing: border-box;
  border-bottom: 1px solid #2e363b;

  span {
    color: #fff;
    font-size: 24px;
    font-weight: 700;
  }

  svg {
    width: 32px;
    height: 32px;
    cursor: pointer;
    display: block;
  }
`

export const SwitchCore = styled('div')`
  padding: 24px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const SwitchLine = styled('div')`
  background-color: #3a5019;
  height: 1px;
  width: 165px;
`

export const ExchangeCurrency = styled('div')`
  color: #95a4ad;
  font-family: 'Source Sans Pro';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin-left: 8px;
`
